import {saveTracecode, saveContactedAdvertisements} from "./tracecode";

$(window).on("load", function () {
	saveTracecode();
	saveContactedAdvertisements();
})